export class IStorageStrategy {}
